import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ChangeImpactAnalysisIcon = () => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32">
    {/* Network/graph showing change propagation */}
    <circle cx="16" cy="8" r="3" fill="#17E88F" />
    <circle cx="9" cy="18" r="3" fill="#0FB870" />
    <circle cx="23" cy="18" r="3" fill="#0FB870" />
    <circle cx="12" cy="26" r="2.5" fill="#0D9359" />
    <circle cx="20" cy="26" r="2.5" fill="#0D9359" />

    {/* Connections */}
    <path
      d="M16 11L9 15M16 11L23 15M9 21L12 23.5M23 21L20 23.5"
      stroke="#17E88F"
      strokeWidth="2"
      strokeLinecap="round"
    />

    {/* Impact indicator (ripple) */}
    <circle
      cx="16"
      cy="8"
      r="5"
      stroke="#17E88F"
      strokeWidth="1"
      fill="none"
      opacity="0.3"
    />
  </SvgIcon>
);

export default ChangeImpactAnalysisIcon;
